module.exports = __webpack_public_path__ + "img/ip.8c437b09.png";